<template>
    <form @submit.prevent="personDescriptionInfo_Submit">
        <div class="card">
            <div class="card-header">
                个人联系信息管理
            </div>
            <div class="card-body">
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right" for="inputDescription">个人简介</label>
                    <div class="col-sm-10">
<!--                        <vue-editor id="inputDescription" v-model="personDescriptionInfo.description"></vue-editor>-->
                        <textarea class="form-control" rows="8" v-model="personDescriptionInfo.description" id="inputDescription"></textarea>
                    </div>
                </div>
                <div class="form-group row mb-0">
                    <label class="col-sm-2 col-form-label text-right" for="inputMemo">备注信息</label>
                    <div class="col-sm-10">
<!--                        <vue-editor id="inputMemo" v-model="personDescriptionInfo.memo"></vue-editor>-->
                        <textarea class="form-control" rows="8" v-model="personDescriptionInfo.memo" id="inputMemo"></textarea>
                    </div>
                </div>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-primary" type="submit">保存</button>
            </div>
        </div>
    </form>
</template>

<script>
import {VueEditor} from "vue2-editor";
import userApi from "@/utils/api/user";
export default {
    name: "OrganPersonDescriptionInfoEdit",
    props: {
        personId: {type: String, required: true},
        personType: {type: Number, required: true},
    },
    components: {
        VueEditor
    },
    data: function () {
        return {
            personDescriptionInfo: {},
        };
    },
    mounted() {
        this.getPersonDescriptionInfo();
    },
    methods: {
        getPersonDescriptionInfo() {
            userApi.person.description.getOrganPersonDescriptionInfo({personId:this.personId, personType: this.personType}).then(res => {
                this.personDescriptionInfo = res.data;
            })
        },

        personDescriptionInfo_Submit() {
            userApi.person.description.updateOrganPersonDescriptionInfo(this.personDescriptionInfo).then(res => {
                this.personDescriptionInfo = res.data;
                alert('信息已保存');
            })
        }
    }
}
</script>

<style scoped>

</style>